import { useState } from "react";
import styles from "./MainButton.module.css";

const MainButton = ({
  children,
  onClick,
  type = "button",
  variant = "dark",
  active = false,
  disabled = false,
  fullWidth = false,
  className = "",
  onMouseEnter,
  onMouseLeave,

  leftIcon,
  leftIconHover,
  leftIconActive,
  leftIconAlt = "",
  leftIconClassName = "",

  rightIcon,
  rightIconHover,
  rightIconActive,
  rightIconAlt = "",
  rightIconClassName = "",
}) => {
  const [isHovered, setIsHovered] = useState(false);

  const isSubmitVariant = variant === "submit";

  const buttonClassName = `
    ${styles.button}
    ${styles[variant] || ""}
    ${isSubmitVariant && !disabled ? styles.submitEnabled : ""}
    ${active ? styles.active : ""}
    ${disabled ? styles.disabled : ""}
    ${fullWidth ? styles.fullWidth : ""}
    ${className}
  `.trim();

  const resolvedLeftIcon = active
    ? leftIconActive || leftIcon
    : isHovered
      ? leftIconHover || leftIcon
      : leftIcon;

  const resolvedRightIcon = active
    ? rightIconActive || rightIcon
    : isHovered
      ? rightIconHover || rightIcon
      : rightIcon;

  return (
    <button
      type={type}
      className={buttonClassName}
      onClick={onClick}
      disabled={disabled}
      onMouseEnter={(e) => {
        setIsHovered(true);
        onMouseEnter?.(e);
      }}
      onMouseLeave={(e) => {
        setIsHovered(false);
        onMouseLeave?.(e);
      }}
    >
      {resolvedLeftIcon && (
        <img
          src={resolvedLeftIcon}
          alt={leftIconAlt}
          className={`${styles.icon} ${leftIconClassName}`}
        />
      )}

      <span className={styles.label}>{children}</span>

      {resolvedRightIcon && (
        <img
          src={resolvedRightIcon}
          alt={rightIconAlt}
          className={`${styles.icon} ${rightIconClassName}`}
        />
      )}
    </button>
  );
};

export default MainButton;